import { render, staticRenderFns } from "./HowItWorksSteps.vue?vue&type=template&id=3b000960&scoped=true"
import script from "./HowItWorksSteps.vue?vue&type=script&lang=ts"
export * from "./HowItWorksSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b000960",
  null
  
)

export default component.exports